import React, { Fragment, useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import { 
    Card, 
    CardActions, 
    CardContent, 
    Grid, 
    Button,
    Backdrop,
    CircularProgress,
    TextField,
    MenuItem,
    FormControl,
	FormLabel,
	FormGroup,
	FormControlLabel,
	Checkbox
} from '@material-ui/core'
import { useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers";
// import * as yup from "yup";
import { useHistory } from 'react-router-dom'
// redux
import { connect } from 'react-redux'
import { dispositionInboxMail } from '../../../../store/actions/suratMasuk'

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
    },
    text: {
        color: '#000000',
        fontFamily: 'Montserrat'
    },
    textWhite: {
        color: '#FFFFFF',
        fontFamily: 'Montserrat'
    },
    button: {
        textTransform: 'none',
        backgroundColor: '#2285DF',
        color: '#FFFFFF',
        width: '100%',
        height: '40px',
        '&:hover': {
            backgroundColor: '#0277BD'
        },
        marginRight: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    buttonSmall: {
        textTransform: 'none',
        backgroundColor: '#2285DF',
        '&:hover': {
            backgroundColor: '#0277BD'
        },
        marginTop: theme.spacing(1)
    },
    divider: {
        color: '#000000',
    },
    backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        width: '100%',
    },
        chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
        chip: {
        margin: 2,
    },
}))

// const DispositionInboxMail = yup.object().shape({
// 	kepada: yup.string().required("Ditujukan harus diisi"),
// });

const Disposisi = props => {
    const classes = useStyles()
    const history = useHistory()
    const { 
        inboxData,
        dispositionInboxMail,
        dispositionChoiceList,
        handleCloseDetailSurat,
        handleCloseDialogDisposisi,
        setKeyword,
        suratMasuk: {
            loadingDispositionInboxMail
        }
    } = props
    const { handleSubmit } = useForm();

    const [ formState, setFormState ] = useState({
        values: {
            catatan: 'Lainnya'
        }
    })

    const handleChange = event => {
        event.persist();
    
        setFormState(formState => ({
          ...formState,
          values: {
            ...formState.values,
            [event.target.name]: 
                event.target.type === 'checkbox'
                ? event.target.checked
                : event.target.value
          }
        }));
    };

    const onSubmit = e => {
        // console.log(inboxData.id, formState.values)
        const word = stateDisposisi.filter((value) => 
            value.isChecked === true
        )
        .map((e) => e.value)
        .reduce((value,element) => value + "," + element)
        dispositionInboxMail(inboxData.id, formState.values, word, history, setKeyword, inboxData.no_surat)
        handleCloseDialogDisposisi()
        handleCloseDetailSurat(inboxData)
    }

    const [stateDisposisi, setStateDisposisi] = useState([
        {
            title: 'Cek kelengkapan',
            value: 'Cek kelengkapan',
            isChecked: false,
            name: 'kelengkapan'
        },
        {
            title: 'Proses sesuai ketentuan dan procedure',
            value: 'Proses sesuai ketentuan dan procedure',
            isChecked: false,
            name: 'prosedur'
        },
        {
            title: 'Laporkan hasilnya',
            value: 'Laporkan hasilnya',
            isChecked: false,
            name: 'laporkan'
        },
        {
            title: 'Datakan/ Filekan',
            value: 'Datakan/ Filekan',
            isChecked: false,
            name: 'datakan'
        },
        {
            title: 'Tindaklanjuti',
            value: 'Tindaklanjuti',
            isChecked: false,
            name: 'tindaklanjut'
        },
        {
            title: 'Wakili',
            value: 'Wakili',
            isChecked: false,
            name: 'wakili'
        },
        {
            title: 'Lainnya',
            value: '',
            isChecked: false,
            name: 'lainnya'
        }
    ])

	const handleChangeWord = (event) => {
        let index = 0
        stateDisposisi.forEach((res) => {
            if(res.name === event.target.name){
                let data = [...stateDisposisi]
                let items = {...data[index]}
                items = {
                    title: event.target.value, 
                    value: event.target.value,
                    isChecked : event.target.checked,
                    name: event.target.name
                }
                data[index] = items
                setStateDisposisi(data)
                if(res.name === 'lainnya'){
                    let data = [...stateDisposisi]
                    let items = {...data[index]}
                    items = {
                        title: formState.values.catatan, 
                        isChecked : event.target.checked,
                        name: event.target.name
                    }
                    data[index] = items
                    setStateDisposisi(data)
                }
            }
            index++
        });
	};

    const handleChangeMoreDisposition = event => {
        let data = [...stateDisposisi]
        let items = {...data[data.length - 1]}
        items = {
            ...items,
            value: event.target.value
        }
        data[data.length - 1] = items
        setStateDisposisi(data)
    }

    return loadingDispositionInboxMail ?
    <Backdrop className={classes.backdrop} open>
        <CircularProgress color="inherit" />
    </Backdrop>
    :
    <Fragment>
        <Card className={classes.root}>

            <CardContent>
                <Grid
                    container
                    spacing={2}
                >
                    <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                    >
                        <TextField
                            fullWidth
                            select
                            name="kepada"
                            value={formState.values.kepada || ''}
                            onChange={handleChange}
                            placeholder="Pilih Bagian"
                            label="Disposisikan Ke"
                            // helperText={
                            //     errors.kepada && errors.kepada.message
                            // }
                            // error={errors.kepada && true}
                            // inputRef={register}
                        >
                            {dispositionChoiceList
                            .filter(e => e.nama !== 'kanit stnk' && e.nama !== 'pamin tu')
                            .map(item => (
                                <MenuItem value={item.id}>{item.nama}</MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                    >
                        <FormControl component="fieldset" className={classes.formControl}>
                            <FormLabel component="legend">Isi Disposisi</FormLabel>
                            <FormGroup>
                                {stateDisposisi.map((item) => (
                                    <FormControlLabel
                                        control={<Checkbox checked={item.isChecked} value={item.value} onChange={handleChangeWord} name={item.name} />}
                                        label={item.title}
                                    />
                                ))}
                            </FormGroup>
                        </FormControl>
                        {stateDisposisi[stateDisposisi.length - 1].isChecked && (
                            <TextField
                                fullWidth
                                name="isi_disposisi"
                                value={stateDisposisi[stateDisposisi.length - 1].value || ''}
                                onChange={handleChangeMoreDisposition}
                                placeholder="Lainnya"
                                label="Catatan"
                                multiline
                                rows={4}
                            />
                        )}
                    </Grid>
                </Grid>
            </CardContent>
            <CardActions>
                <Grid
                    container
                    justify="space-between"
                >
                    <Grid item>
                        <Button className={classes.button} onClick={handleSubmit(onSubmit)}>
                            <div className={classes.textWhite}>
                                Submit
                            </div>
                        </Button>
                    </Grid>
                </Grid>
            </CardActions>
        </Card>
    </Fragment>
    
}

const mapStateToProps = state => ({
    suratMasuk: state.suratMasuk
})

export default connect(mapStateToProps, { dispositionInboxMail })(Disposisi)